import type { PropsWithChildren } from 'react';
import { useTranslation } from 'translations/hooks';
import { Page } from 'ui/layout';

export const AnonymousRoute = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();

  return <Page title={t('header.title')}>{children}</Page>;
};
